<template>
  <div class="container">
    <common-head></common-head>
    <div class="inner">
      <div class="new-bk-page">
        <div class="n-page-left">
          <div class="title">Hot</div>
          <div class="best-top">
            <ul class="best-list">
              <li class="item" v-for="(item, index) of bestData" :key="item.ID" :index="index"
                :class="{ active: isActive === index }" @mouseenter="enterFun(index)" @mouseleave="leaveFun(index)">
                <div class="index-num">0{{ index + 1 }}</div>
                <div class="b-grp">
                  <div class="thm-o">{{ item.Name }}</div>
                  <div class="thm-t">
                    <div class="img">
                      <a href="javascript:;" @click="$fun.openProductUrl(item.Id, item.ProductType)">
                        <!-- <div class="img-tag1">{{item.SOURCEOPENTYPE ==="01" ? '借阅' : '畅读' }}</div> -->
                        <template v-if="item.Cover"><img :src="item.Cover" /></template>
                        <template v-else><img src="/static/img/np-img.png" /></template>
                        <!-- <span class="img-tag">{{item.ProductTypeText}}</span> -->
                      </a>
                    </div>
                    <div class="info-t">
                      <div class="name"><a href="javascript:;" @click="$fun.openProductUrl(item.Id, item.ProductType)">{{
                        item.Name }}</a></div>
                      <div class="author">{{ item.Author }}</div>
                      <div class="dec" v-if="item.Introduction">{{ $fun.delHtmlTag(item.Introduction) }}</div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="n-page-right">
          <div class="n-page-hd">
            <div class="ti">{{ model.COLUMNNAME }}</div>
            <div class="opt-li" v-show="false">
              <div class="item" v-for="(item, index) of optionList" :key="item.Id" :index="index"
                :class="{ active: productType === item.TYPE }" @click="changeType(item.TYPE)">
                {{ item.NAME }}
              </div>
            </div>
          </div>
          <div class="n-page-bd">
            <ul class="search-result-list">
              <li class="item" v-for="(item, index) of pageData">
                <div class="img">
                  <a href="javascript:;" @click="$fun.openProductUrl(item.Id, item.ProductType)">
                    <!-- <div class="img-tag1">{{item.SOURCEOPENTYPE ==="01" ? '借阅' : '畅读' }}</div> -->
                    <template v-if="item.Cover">
                      <img :src="item.Cover" />
                    </template>
                    <template v-else>
                      <img src="/static/img/np-img.png" />
                    </template>
                    <!-- <span class="img-tag">{{item.ProductTypeText}}</span> -->
                  </a>
                </div>
                <div class="s-info">
                  <div class="name">
                    <a href="javascript:;" @click="$fun.openProductUrl(item.Id, item.ProductType)">{{ item.Name }}</a>
                    <!-- <el-tag size="mini" type="warning" effect="dark">{{ item.ProductTypeText }}</el-tag> -->
                  </div>
                  <div class="sr-para">{{ item.Author }}</div>
                  <div class="dec" v-if="item.Introduction">{{ $fun.delHtmlTag(item.Introduction) }}</div>
                  <el-button :type="item.IsCollect ? 'danger' : 'primary'" size="mini" @click="$fun.addCollect(item)"
                    v-show="accountShow">{{
                      item.IsCollect ? '- Book shelf' : '+ Book shelf' }}</el-button>
                </div>
              </li>
            </ul>
            <el-empty description="NULL" v-show="pageData.length == 0"></el-empty>
            <el-pagination layout="prev, pager, next, jumper, total, sizes" class="m-page-list" background
              @size-change="changeSize" @current-change="changePage" :current-page="pageNo"
              :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pageSize" :total="pageTotal">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <common-foot></common-foot>
  </div>
</template>

<script>
import CommonHead from "common/head/Head";
import CommonFoot from "common/foot/Foot";
export default {
  name: "Recommend",
  components: {
    CommonHead,
    CommonFoot,
  },
  data: function () {
    return {
      model: {
        ID: this.$route.params.id,
      },
      pageData: [],
      bestData: [],
      optionList: [
        {
          TYPE: "",
          NAME: "全部",
        },
      ],
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      isActive: 0,
      productType: "",
      path: "",
      accountShow: false
    };
  },
  mounted: function () {
    if (this.path === "") {
      this.path = this.$route.params.id;
    }
    this.loadInfo();
    this.loadList();
    this.loadBest();
    this.$bti.GetColumnTypeList({ orgId: this.http.GetOrgInfo().OrgId, isCategory: true, isParent: true }).then((res) => {
      this.optionList.push(...res.data);
    });
    // this.$bti.GetListByColumnType().then((res) => {
    //   this.optionList.push(...res.data);
    // });

    //如果不是ip免登录用户则显示加入书架按钮
    let userid = this.jwt_decode(window.localStorage.Token).userId;
    if (userid != '13400000001') {
      this.accountShow = true;
    }
  },
  watch: {
    $route(to, from) {
      this.path = to.path.replace('/recommend/', '');
      this.loadInfo();
      this.loadList();
      this.loadBest();
      this.optionList = [
        {
          TYPE: "",
          NAME: "全部",
        },
      ];
      this.$bti.GetColumnTypeList({ orgId: this.http.GetOrgInfo().OrgId, isCategory: true, isParent: true }).then((res) => {
        this.optionList.push(...res.data);
      });
    }
  },
  methods: {
    loadInfo: function () {
      this.$bti.GetColumnInfo({ "id": this.$route.params.id }).then((res) => {
        if (res.data.data.ORGID != this.http.GetOrgInfo().OrgId) {
          this.$router.push({ name: "Home" });
          return;
        }
        this.model = res.data.data;
      });
    },
    loadList: function () {
      var params = {
        page: this.pageNo,
        rows: this.pageSize,
        wheres: {
          ColumnId: this.path,
          ProductType: this.productType,
          OrgId: this.$fun.getMember().orgId,
          CheckCollect: true
        },
      };
      this.$bti.GetBelongToColumnPage(params).then((res) => {
        if (res.code != 1) {
          this.pageData = [];
          return;
        }
        this.pageData = res.data.rows;
        this.pageTotal = res.data.total;
      });
    },
    loadBest: function () {
      this.$bti.GetBelongToColumnPage({ page: 1, rows: 10, wheres: { ColumnName: "畅读榜", IsSingle: true, OrgId: this.$fun.getMember().orgId } }).then((res) => {
        if (res.code != 1) {
          return;
        }
        this.bestData = res.data.rows;
      });
    },
    enterFun: function (index) {
      this.isActive = index;
    },
    leaveFun: function (index) {
      this.isActive = index;
    },
    changeType: function (val) {
      this.productType = val;
      this.pageNo = 1;
      this.loadList();
    },
    changePage: function (val) {
      this.pageNo = val;
      this.loadList();
    },
    changeSize: function (val) {
      this.pageSize = val;
      this.loadList();
    }
  },
};
</script>

<style lang="css" scoped>
.new-bk-page {
  padding: 30px 0px;

  /* margin-bottom: 50px; */
}

.new-bk-page:after,
.thm-t:after,
.n-page-right .n-page-hd:after,
.search-result-list .item:after {
  display: block;
  overflow: hidden;
  clear: both;
  height: 0;
  visibility: hidden;
  content: "";
}

.n-page-left {
  float: left;
  width: 343px;
  background: #fff;
}

.n-page-right {
  float: right;
  width: 832px;
  width: calc(100% - 368px);
  background: #fff;
  padding: 40px 40px 20px 40px;
}

.n-page-left .title {
  font-size: 20px;
  font-weight: bold;
  font-style: italic;
  padding: 30px 30px 10px 30px;
}

.best-list .item:not(:last-child) {
  border-bottom: 2px solid #eee;
}

.best-list .item {
  padding: 15px 30px;
}

.best-list .item:after {
  display: block;
  overflow: hidden;
  clear: both;
  height: 0;
  visibility: hidden;
  content: "";
}

.best-list .item .index-num {
  float: left;
  width: 40px;
  font-size: 14px;
}

.best-list .item .b-grp {
  float: right;
  width: 183px;
  width: calc(100% - 40px);
}

.best-list .item .thm-o {
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.best-list .item .thm-t {
  display: none;
}

.best-list .item.active .thm-o {
  display: none;
}

.best-list .item.active .thm-t {
  display: block;
}

.b-grp .thm-t .img {
  float: left;
  width: 109px;
  height: 141px;
  box-shadow: 0px 0px 5px #ccc;
  position: relative;
}

.b-grp .thm-t .img a {
  display: block;
  cursor: pointer;
  width: 109px;
  height: 141px;
  position: relative;
}

.b-grp .thm-t .img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.b-grp .info-t {
  float: right;
  width: 114px;
  width: calc(100% - 129px);
}

.b-grp .info-t .name {
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 10px 0px;
}

.b-grp .info-t .name a {
  color: #333;
}

.b-grp .info-t .author {
  padding-bottom: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.b-grp .info-t .dec {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  width: 100%;
}

.best-list .item.active .index-num {
  font-size: 24px;
  font-style: italic;
}

.best-list .item.active:nth-child(1) .index-num,
.best-list .item.active:nth-child(2) .index-num,
.best-list .item.active:nth-child(3) .index-num {
  color: #c1301d;
}

.n-page-right .n-page-hd {
  position: relative;
  padding-bottom: 30px;
}

.n-page-right .n-page-hd .ti {
  font-size: 20px;
  font-weight: bold;
  font-style: italic;
}

.n-page-right .n-page-hd .opt-li {
  position: absolute;
  right: 0;
  top: 0px;
}

.n-page-right .n-page-hd .opt-li .item {
  float: left;
  border: 1px solid #ed7d31;
  padding: 3px 15px;
  margin: 0px 5px;
  border-radius: 20px;
  color: #ed7d31;
  font-weight: bold;
  cursor: pointer;
}

.n-page-right .n-page-hd .opt-li .item.active {
  background: #ed7d31;
  color: #fff;
}

.search-result-list .item {
  padding: 15px 0px;
}

.search-result-list .item .img {
  float: left;
  width: 136px;
  height: 179px;
  overflow: hidden;
  box-shadow: 0px 0px 5px #ccc;
}

.search-result-list .item .img a {
  display: block;
  cursor: pointer;
  width: 100%;
  height: 100%;
}

.search-result-list .item .img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.search-result-list .item .s-info {
  position: relative;
  float: right;
  width: 669px;
  width: calc(100% - 166px);
}

.search-result-list .item .s-info .name {
  position: relative;
  height: 35px;
  line-height: 35px;
  width: 80%;
  overflow: hidden;
}

.search-result-list .item .s-info .name a {
  display: inline-block;
  color: #252525;
  font-size: 14px;
  font-weight: bold;
  max-width: 78%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.search-result-list .item .s-info .name .el-tag {
  position: relative;
  top: -12px;
  margin-left: 15px;
}

.search-result-list .item .s-info .sr-para {
  margin-bottom: 10px;
}

.search-result-list .item .s-info .dec {
  font-size: 14px;
  padding: 15px 0px;
  line-height: 1.8;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  width: 100%;
  height: 90px;
}

.search-result-list .item .el-button {
  position: absolute;
  right: 0px;
  top: 10px;
}

.img {
  position: relative;
}

.img .img-tag1 {
  position: absolute;
  top: 0;
  right: 0;
  width: 48px;
  height: 48px;
  background: linear-gradient(-135deg, #409EFF, #409EFF 50%, transparent 50%, transparent 100%);
  color: #fff;
  padding-left: 19px;
}
</style>



// WEBPACK FOOTER //
// src/pages/recommend/Recommend.vue